import { types } from "mobx-state-tree"
import validate from 'validate.js'

const Dirty = types.model({
    token: types.optional(types.boolean, false),
    campaignPrefix: types.optional(types.boolean, false),
})

const AccountUIStore = types.model({
    token: types.optional(types.string, ''),
    campaignPrefix: types.optional(types.string, ''),
    dirty: types.optional(Dirty, Dirty.create())
})
.actions(self=>({
    setToken: (value)=>{
        self.dirty.token = true
        self.token = value;
    },
    setCampaignPrefix: (value)=>{
        self.dirty.campaignPrefix = true
        self.campaignPrefix = value;
    }
}))
.views(self=>({
    get errors(){
        var constraints = {
            campaignPrefix: {
              presence: {message: 'Group missing', allowEmpty: false},
            },
            token: {
              presence: {message: 'Token missing', allowEmpty: false},
            },
          };
          return validate({campaignPrefix: self.campaignPrefix, token: self.token}, constraints, {fullMessages: false})
    },
}))

export default AccountUIStore.create({})


// WEBPACK FOOTER //
// ./src/stores/AccountUIStore.js